import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { WindowSizeController } from '@adornis/chemistry/controllers/window-size-controller.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { goTo } from '@adornis/router/client/open-href.js';
import '@chancenwerk/design/components/cr-button.js';
import '@chancenwerk/design/components/cr-flex.js';
import '@chancenwerk/design/components/cr-image.js';
import '@chancenwerk/design/components/fonts.js';
import { html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import biologie from '../assets/Biologie_Alpha.png';
import chemie from '../assets/Chemie_Alpha.png';
import landing_1 from '../assets/landing_1_alpha.png';
import landing_2 from '../assets/landing_2_alpha.png';
import landing_3 from '../assets/landing_3_alpha.png';
import landing_bubbles from '../assets/landing_bubbles.png';
import { CampusRoutes } from './../routes.js';

@customElement('campus-page-landing')
export class CampusLandingPage extends ChemistryLitElement {
  override styles() {
    return [
      {
        ':host': {
          display: 'flex',
          height: '100%',
        },

        '@media screen and (max-height: 786px)': {
          ':host > cr-flex': {
            gap: this.spacing.md,

            '&> cr-flex': {
              gap: this.spacing.md,
            },

            'cr-image': {
              maxWidth: '128px',
              maxHeight: '128px',
            },
          },
        },

        '@media screen and (max-height: 642px)': {
          ':host > cr-flex': {
            padding: this.spacing.xs,

            '& > cr-flex': {
              padding: '0',
            },

            '.image-chain': {
              gap: this.spacing.xl,

              'cr-image': {
                maxWidth: this.spacing.xxl,
                maxHeight: this.spacing.xxl,
              },
            },
          },
        },
      },
    ];
  }

  size = new WindowSizeController(this);
  override render() {
    return html`
      <cr-flex
        padding="xl"
        space="lg"
        vertical
        ${css({ margin: 'auto', alignItems: this.size.mobile ? '' : 'center' })}
      >
        <cr-h1 ${css({ color: this.colors.primary, textAlign: 'center' })}> Herzlich Willkommen! </cr-h1>

        <cr-flex padding="lg" space="lg">
          <cr-text
            ${css({ fontSize: '1.3rem', lineHeight: '1.5rem' })}
            ${this.size.tablet ? nothing : css({ maxWidth: '40vw' })}
          >
            Der ChancenCAMPUS ist die eigene Lernplattform von Chancenwerk e.V. Wir stellen dir hier verschiedene
            Lerninhalte zur Verfügung, ebenso digitale Intensivkurse und Prüfungsvorbereitung in kleinen Lerngruppen.
            Unsere Plattform befindet sich noch im Aufbau und wird laufend um neue Inhalte und Funktionen erweitert.
          </cr-text>
          <cr-text ${css({ fontSize: '1.3rem', lineHeight: '1.5rem', fontStyle: 'italic' })}> Schau vorbei! </cr-text>
        </cr-flex>
        ${this.size.mobile
          ? nothing
          : html`
              <cr-flex class="image-chain" horizontal space="md">
                <cr-image
                  loading="eager"
                  ${css({ width: '10vw' })}
                  is-url
                  .value=${landing_bubbles}
                  mode="inline"
                ></cr-image>
                <cr-image loading="eager" ${css({ width: '15vw' })} is-url .value=${landing_1} mode="inline"></cr-image>
                <cr-image loading="eager" ${css({ width: '15vw' })} is-url .value=${landing_2} mode="inline"></cr-image>
                <cr-image loading="eager" ${css({ width: '15vw' })} is-url .value=${landing_3} mode="inline"></cr-image>
                <cr-image loading="eager" ${css({ width: '15vw' })} is-url .value=${chemie} mode="inline"></cr-image>
                <cr-image loading="eager" ${css({ width: '15vw' })} is-url .value=${biologie} mode="inline"></cr-image>
              </cr-flex>
            `}

        <cr-flex horizontal space-between>
          <cr-button
            icon="arrow_forward"
            ${css({ backgroundColor: this.colors.primary, borderColor: this.colors.primary, width: '100%' })}
            @click=${async () => goTo(CampusRoutes.dashboard)}
          >
            zur Anmeldung/Registrierung
          </cr-button>
        </cr-flex>
      </cr-flex>
    `;
  }
}
